/**
 * The resolved writing direction at `node`, from the nearest `[dir]` ancestor.
 *
 * `document.documentElement.dir` alone would miss an RTL subtree inside an LTR
 * page (an Arabic name rendered in an English console), and
 * `getComputedStyle().direction` — the fully correct answer — is not reliably
 * inherited in jsdom, where callers of this are tested. `closest('[dir]')`
 * reaches `<html dir="rtl">` as well as any nearer override, so it is right in
 * both places.
 */
export function isRtl(node: HTMLElement | null): boolean {
  const dir =
    node?.closest('[dir]')?.getAttribute('dir') ??
    (typeof document === 'undefined' ? '' : document.documentElement.dir);
  return dir.toLowerCase() === 'rtl';
}
